let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fAEbb")).then(() => parcelRequire('7yUy4'));